import {translate} from '../../../shared/mixins/translation';
import CharacteristicView from './CharacteristicView';
import AuthorizationGroup from '../form/AuthorizationGroup.js';

export default class SeatView {
    constructor(json) {
        this.blocked = json.blocked;
        this.id = json.id;
        this.number = json.number;
        this.defaultName = translate('app.seatDetails.seat_name', {
            '%number%': this.number,
        });
        this.name = json.name ?? '';
        this.locationX = json.locationX;
        this.locationY = json.locationY;
        this.locationName = json.locationName;
        this.locationId = json.locationId;
        this.floorName = json.floorName;
        this.roomName = json.roomName;
        this.room = json.room;
        this.isFavorite = json.favorite || json.isFavorite;
        this.authorizationGroups =
            json.authorizationGroups?.map(
                authorizationGroup =>
                    new AuthorizationGroup(
                        authorizationGroup.space,
                        authorizationGroup.company,
                        authorizationGroup.departments,
                        authorizationGroup.teams,
                        authorizationGroup.users
                    )
            ) ?? [];

        this.characteristics =
            json.characteristics?.map(characteristic => new CharacteristicView(characteristic)) ??
            [];
        this.profileImage = json.profileImage;
        this.initials = json.initials;
        this.message = json.message;
        this.imageName = json.imageName;
        this.costCenterRequired = json.costCenterRequired;
    }

    static createEmpty() {
        return new SeatView({
            id: '',
            number: -1,
            name: '',
            locationX: -1,
            locationY: -1,
            defaultName: '',
            blocked: false,
            characteristics: [],
            floorName: '',
            locationName: '',
            locationId: '',
            room: '',
            roomName: '',
            authorizationGroups: [],
            calendarResourceId: '',
            isFavorite: false,
            costCenterRequired: false,
        });
    }
}
